import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Pastillas farmacéuticas',
    reason: 'Fallaron porque crean adicción y somnolencia diurna en 2 semanas.'
  }, {
    title: 'Tés de supermercado genéricos',
    reason: 'Fallaron porque son polvo procesado con dosis bajas que no suben tu GABA real.'
  }, {
    title: 'Apps de meditación',
    reason: 'Fallaron porque no atacan la química raíz — solo distraen, pero tu cortisol sigue alto.'
  }, {
    title: 'Melatonina en píldoras',
    reason: 'Fallaron porque tu cuerpo ignora las hormonas sintéticas si no hay rotación.'
  }, {
    title: "Alcohol como 'ayuda'",
    reason: 'Falló porque fragmenta tu sueño REM. Te desmayas, pero no descansas. Peor mañana.'
  }];
  return <section className="py-12 md:py-20 px-4 bg-forest-900" data-id="element-2">
      <div className="max-w-3xl mx-auto" data-id="element-3">
        <div className="text-center mb-8 md:mb-16" data-id="element-4">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-gold-500 mb-4" data-id="element-5">
            Lo Que Ya Intentaste <br data-id="element-6" />
            (Y Por Qué No Funcionó)
          </motion.h2>
          <p className="text-cream-300" data-id="element-7">
            No es tu culpa que nada de esto haya resuelto el problema de raíz.
          </p>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-8">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-forest-800 border-l-4 border-red-500/70 p-4 md:p-6 rounded-r-lg flex gap-3 md:gap-4 items-start hover:bg-forest-700 transition-colors" data-id="element-9">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-10" />
              <div data-id="element-11">
                <h3 className="text-lg font-bold text-cream-100 mb-1" data-id="element-12">
                  {item.title}
                </h3>
                <p className="text-cream-300" data-id="element-13">{item.reason}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-8 md:mt-12 text-center p-4 md:p-6 bg-forest-800/50 rounded-xl border border-forest-600" data-id="element-14">
          <p className="text-lg md:text-xl font-serif text-gold-400" data-id="element-15">
            No eres débil — tienes el cortisol alto y el GABA bajo por turnos
            eternos.
          </p>
        </motion.div>
      </div>
    </section>;
}